import React, { useEffect, useState } from "react";
import { Grid } from "@mui/material";
import Navbar from "../Navbar";
import axios from "axios";
import Button from "@mui/material/Button";
import { Link, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  createTheme,
  PaletteColorOptions,
  ThemeProvider,
} from "@mui/material/styles";
import { Stack } from "@mui/material";

axios.defaults.headers.common = {
  "X-Requested-With": "XMLHttpRequest",
  "X-CSRF-TOKEN": window.csrf_token,
};

function Usermaster() {
  const [loading, setLoading] = useState(true);
  const [categorylist, setCategorylist] = useState([]);

  useEffect(() => {
    axios.get(`api/users`).then((res) => {
      if (res.status === 200) {
        setCategorylist(res.data.users);
      }
      setLoading(false);
    });
  }, []);

  const { palette } = createTheme();
  const { augmentColor } = palette;
  const createColor = (mainColor) =>
    augmentColor({ color: { main: mainColor } });
  const theme = createTheme({
    palette: {
      anger: createColor("#F40B27"),
      apple: createColor("#A38A00"),
      steelBlue: createColor("#5C76B7"),
      violet: createColor("#BC00A3"),
    },
    button: {
      // Here is where you can customise the button
      fontSize: 16,
      fontWeight: 1700,
    },
  });

  const deleteUser = (e, id) => {
    e.preventDefault();
    let userId = localStorage.getItem("auth_id");
    console.log(userId);
    const data= {user_id:userId,};

    const thisClicked = e.currentTarget;
    thisClicked.innerText = "Deleting";

    axios.post(`api/delete-user/${id}`,data).then((res) => {
      if (res.data.status === 200) {
        swal("Success", res.data.message, "success");
        thisClicked.closest("tr").remove();
      } else if (res.data.status === 404) {
        swal("Success", res.data.message, "success");
        thisClicked.innerText = "Delete";
      }
    });
  };

  var viewcategory_HTMLTABLE = "";
  if (loading) {
    swal({
      title: "Loading",
      text: "Please Wait!!!",
      timer: 1000,
      buttons: false,
    }).then(
      function () {},
      // handling the promise rejection
      function (dismiss) {
        if (dismiss === "timer") {
          //console.log('I was closed by the timer')
        }
      }
    )
  }
  else{
      viewcategory_HTMLTABLE = 
      categorylist.map((item)=>{
          return(
              <tr key={item.id}>
                  <td >{item.id}</td>
                  <td sx={{ border: 1 }}>{item.name}</td>
                  <td sx={{ border: 1 }}>{item.email}</td>
                  <td sx={{ border: 1 }}>{item.created_at}</td>
                  <td>
                  <Grid container spacing={2}>                                                                                                                
                  <Grid item xs={3}>
                  <ThemeProvider theme={theme}>
                  <Button component={Link} to={`/certificates/view-user/${item.id}`} color="apple" size="large" startIcon={<VisibilityIcon color='inherit'/>}/>
                  </ThemeProvider>
                  </Grid>
                  <Grid item xs={3}>
                  <Button  onClick={(e) => deleteUser(e, item.id)} color="primary" size="large" startIcon={<DeleteIcon color='error'/>}/>
                  {/* <td><Link to="#" className="btn btn-success btn-sm">View</Link></td>
                  <td><button type="button" onClick={(e) => deleteUser(e, item.id)} className="btn btn-danger bt-sm">Delete</button></td> */}
              </Grid>
            </Grid>
          </td>
        </tr>
      );
    });
  }

  return (
    <div>
      <Navbar />
      <div className="card px-8 m-5">
        <div className="card-header">
          <h4>User Master</h4>
        </div>
        <div className="card-body">
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Created DateTime</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>{viewcategory_HTMLTABLE}</tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Usermaster;
